/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';

import AutoProfilePageMenu from '../reusable/AutoProfilePageMenu';
import AutoProfileTopMenu from '../reusable/AutoProfileTopMenu';
import StatusDiagram from '../reusable/StatusDiagram';

import StatusParameters from './StatusParameters';

import './AutoProfileParameters.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  currentProfileParams: store.setupStore.currentProfileParams,
}))
class AutoProfileParameters extends React.PureComponent {
  componentDidMount() {
    const {currentProfileParams, dispatch} = this.props;

    if (PC_COMMON_FUNCTION.isAllAutoProfileParamFilled(currentProfileParams) === true) {
      dispatch(setupActions.isCompleteFill(true));
    } else {
      dispatch(setupActions.isCompleteFill(false));
    }
    dispatch(setupActions.updateActiveMenu(APPDATA.AUTO_PROFILE_PARAMETERS_TAB));
  }

  componentWillUnmount() {
    const {dispatch} = this.props;
    dispatch(setupActions.topButtonSecondaryProperties(undefined));
  }

  render() {
    const {fontSize} = this.props;

    const style = {
      constraint: {
        fontSize: fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : fontSize,
      },
    };

    return (
      <div style={style.constraint}>
        <div className="row AutoProfilStatusRow auto-profile-params">
          <div className={`${APPSTYLE.COLUMN_9}col-statusBox no-padding`}>
            <div className={`${APPSTYLE.COLUMN_FULL}statusBox no-padding`}>
              <StatusParameters />
            </div>
          </div>
          <div className={`${APPSTYLE.COLUMN_3}col-canvas center`}>
            <StatusDiagram />
          </div>
        </div>
        <AutoProfileTopMenu
          activeTopMenu={APPDATA.AUTO_PROFILE_PARAMETERS_TAB}
          titleTopMenu={APPDATA.AUTO_PROFILE.toUpperCase()}
        />
        <AutoProfilePageMenu />
      </div>
    );
  }
}

export default AutoProfileParameters;
